import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import {
  botPageGuard,
  introGuard,
  ruoloConvenzionatoAbilitatoGuard,
  userVerifiedGuard
} from './core/guards/routes.guard';
import { tokenGuard } from './core/guards/token.guard';

export const routes: Routes = [
  // Route catch-all per gestire ticket SSO anche quando c'è un path (es. /manifestazione?ticket=...)
  // Questa route deve essere prima delle route protette per intercettare il ticket
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./pages/public/root-handler/root-handler.component').then(m => m.RootHandlerComponent),
  },
  // Gestioen SSO senza profilo
  {
    path: 'app-no-profilo',
    loadComponent: () => import('./pages/public/root-handler/root-handler.component').then(m => m.RootHandlerComponent),
  },
  {
    path: 'manifestazione',
    loadComponent: () => import('./pages/public/root-handler/root-handler.component').then(m => m.RootHandlerComponent),
  },
  {
    path: 'convenzionato',
    loadComponent: () => import('./pages/public/root-handler/root-handler.component').then(m => m.RootHandlerComponent),
  },
  {
    path: 'promotore',
    loadComponent: () => import('./pages/public/root-handler/root-handler.component').then(m => m.RootHandlerComponent),
  },
  {
    path: 'intro',
    loadComponent: () => import('./pages/public/intro/intro.page').then(m => m.IntroPage),
  },
  {
    path: 'signup',
    loadChildren: () =>
      import('./pages/public/sign-up/sign-up.module').then(
        (m) => m.SignUpPageModule
      ),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/public/login/login.module').then(
        (m) => m.LoginPageModule
      ),
    canActivate: [introGuard],
  },
  {
    path: 'recovery',
    loadChildren: () =>
      import('./pages/public/reset-password/reset-password.module').then(
        (m) => m.ResetPasswordPageModule
      ),
  },
  {
    path: 'app-download',
    loadChildren: () =>
      import('./pages/public/app-download/app-download.module').then(
        (m) => m.AppDownloadPageModule
      ),
  },
  {
    path: 'app',
    loadChildren: () =>
      import('./pages/private/dashboard-main/dashboard-main.module').then(
        (m) => m.DashboardMainPageModule
      ),
    canActivate: [tokenGuard, authGuard]
  },
  {
    path: 'app/manifestazione',
    canActivate: [userVerifiedGuard],
    loadChildren: () =>
      import('./pages/private/dashboard-manifestazione/dashboard-premi.module').then(
        (m) => m.PremiDashboardPageModule
      ),
  },
  {
    path: 'app/convenzionato',
    canActivate: [userVerifiedGuard, ruoloConvenzionatoAbilitatoGuard],
    loadChildren: () =>
      import(
        './pages/private/dashboard-convenzionato/dashboard-convenzionato.module'
      ).then((m) => m.ConvenzionatoDashboardPageModule),
  },
  {
    path: 'app/promotore',
    canActivate: [userVerifiedGuard],
    loadChildren: () =>
      import(
        './pages/private/dashboard-promotore/dashboard-promotore.module'
      ).then((m) => m.PromotoreDashboardPageModule),
  },
  {
    path: 'app/bot',
    canActivate: [botPageGuard],
    loadChildren: () =>
      import(
        './pages/private/dashboard-main/bot/bot.module'
      ).then((m) => m.BotPageModule),
  },
  {
    path: '**',
    redirectTo: 'app',
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      onSameUrlNavigation: 'reload',
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
